import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import { HashLink } from 'react-router-hash-link';


class Lsd extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {

        return (
            <div>
                <Navbar head="LSD" />
                <div className="container" style={{ marginTop: "60px" }}>
                    <HashLink to='/faq#lsd'>
                        <button id="myBtn" title="FAQ">
                            <i class="fas fa-info-circle faqicon"></i>
                            <p>  FAQ</p>
                        </button>
                    </HashLink>

                    <div className="row justify-content-center">
                        <div className="col-12 text-center ">
                            <img className="img-fluid" src="/assests/images/educationLSD.png" alt="Lsd">
                            </img>

                        </div>
                    </div>

                    <div className="content">
                        <h4>What are Hallucinogens? (includes LSD, PCP, MDMA)</h4>
                        <p>Hallucinogens are a diverse group of drugs that alter an individual’s awareness of their surroundings, thoughts and feelings. They can also cause hallucinations which are sensations or images that feel real but are not. Most hallucinogens are either extracted from plants/mushrooms or synthetically developed.</p>

                        <p>LSD (or d-lysergic acid diethylamide) is a mind-altering chemical which is a clear or white, odourless substance. It is used as tablets, pills, or through blotters. Common slangs include acid, blotter, lucy, and boomer. </p>


                        <p>Short term effects include-</p>
                        <ul style={{ fontSize: "large" }}>
                            <li><b>Hallucinations or “trips”</b> (take effect within 20-90 minutes but can last for 12 hours)</li>
                            <li>Increased heart rate, blood pressure, body temperature</li>
                            <li>Nausea</li>
                            <li><b>Intensified feelings</b> and sensory experiences (for example, seeing brighter colours)</li>
                            <li>Changes in sense of time (feeling that time is passing slowly)</li>
                            <li><b>Uncoordinated movements</b></li>
                            <li>Panic and <b>paranoia</b></li>
                            <li><b>Psychosis</b></li>
                        </ul>

                        <p>Long term effects include-</p>

                        <ul style={{ fontSize: "large" }}>
                            <li><b>Persistent psychosis</b>, which refers to a <b>series of continuing mental problems</b> like visual disturbances, disorganized thinking, paranoia, mood changes</li>
                            <li><b>Hallucinogen Persisting Perception Disorder (HPPD)</b> which means recurrence of drug-using experience like <b>hallucinations in the form of flashbacks</b>. This can occur even after significant time has passed from substance intake.</li>
                        </ul>

                    </div>
                </div>
            </div>
        )
    }
}

export default Lsd;